/*
 * @Description:营销活动列表
 * @Author: hujingyang
 * @LastEditors: yang chenglin
 */

import React, { useEffect, useState } from 'react';
import { Balloon, Button, DatePicker, Dialog, Form, Input, Message, Select, Table } from '@alifd/next';
import style from './index.module.scss';
import ParagraphTitle from '@/components/ParagraphTitle';
import LzPagination from '@/components/common/LzPagination';
import LzTag from '@/components/common/LzTag';
import moment from 'moment';
import icon_warning from '@/pages/OrderSelection/icon/iconWarning.svg';
import { appHistory } from '@ice/stark-app';
import utils from '@/common/utils';
import { Servlets } from '@/service';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;

/** 营销活动列表 */
const Tabs_marketingActivityList = (): JSX.Element => {
  const [isLoadingForList, setLoadingForList] = useState(false);// 是否正在加载列表数据
  const [searchFormData, setSearchFormData] = useState({
    name: '', // 营销主题
    status: '', // 活动状态
    type: 2, // 活动类型 1:人群营销 2：订单筛选营销
    createStartTime:  '', // 创建时间 开始
    createEndTime:  '', // 创建时间 结束

    pushStartTime:  '', // 推送时间 起始
    pushEndTime:  '', // 推送时间 结束

  });// 搜索表单数据集合
  const [dataSource, setDataSource] = useState([]);// 列表数据
  const [columns, setColumns] = useState([{}]);// 列表title
  const [orderStatusDisc, setOrderStatusDisc] = useState([{ value: '', label: '' }]);// 订单状态字典
  // const [openMarketingEffectDialog, setOpenMarketingEffectDiglog] = useState(false);//是否打开营销效果模态框
  // const [selectedRowData, setSelectedRowData] = useState({});//用户点击 【营销效果按钮】 所在行的数据，用于传入子页面
  const defaultTimeValues = [
    moment("00:00:00", "HH:mm:ss", true),
    moment("23:59:59", "HH:mm:ss", true)
  ];
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10, total: 0 }); // 分页数据

  useEffect(() => {
    init();
  }, []);


  /** 初始化函数 */
  const init = (): void => {
    setColumns(getColumns());

    getPageData();
  };
  /**  获取数据 */
  const getPageData = (): void => {
    // 订单状态字典
    const getOrderStatusDisc = [
      // { value: 'order_all_status', label: '全部状态' },
      // { value: 'order_waitConfirm', label: '待确认' },
      // { value: 'order_unpaid', label: '待支付订单' },
      // { value: 'order_prepareGoods', label: '备货中' },
      // { value: 'order_afterSale', label: '售后中' },
      // { value: 'order_shipped', label: '已发货' },
      // { value: 'order_finish', label: '完成订单' },
      // { value: 'order_closed', label: '已关闭' },
      // { value: 'order_fastShipments', label: '24H需发货' },
      // { value: 'order_overtime', label: '超时未发货' },
      // bug 76911
      { value: 0, label: '未执行',},
      { value: 1, label: '执行中',},
      { value: 2, label: '执行成功',},
      { value: 3, label: '执行失败',},
      { value: 4, label: '停止',},
    ];
    setOrderStatusDisc(getOrderStatusDisc);

    // setLoadingForList(true);
    // setTimeout(() => {
    //     setLoadingForList(false);

    //     // 获取列表数据
    //     setDataSource(getPageDataSource());
    // }, 500);

    getListData();
  };

  /** 获取列表数据 */ // type: 1-人群营销 2-订单筛选营销
  const getListData = (searchForm = { pageNo: 1, pageSize: 10}): void => {
    setLoadingForList(true);
    // setTimeout(() => {
    //     // 获取列表数据
    //     setDataSource(getPageDataSource(pages));
    // }, 500);

    // 获取订单筛选列表数据
    Servlets('getMarketingtasksListOld', { ...searchForm, type: 2  }, false)
      .then((res: { data: []; page: { pageNo: number; pageSize: number; total: number } }) => {
        setLoadingForList(false);// 关闭loading

        setDataSource(res.data ? res.data : []); // 获取列表数据

        setPageInfo({
          ...pageInfo,
          pageNo: res.page.pageNo,
          pageSize: res.page.pageSize,
          total: res.page.total,
        });// 设置分页
      })
      .catch((err) => {
        console.log(err);
      });
  };
  /** 列表元数据（mock） */
  const getPageDataSource = (numer = 10): object[] => {
    let result = [{}];
    for (let i = 0; i < numer; i++) {
      if (!i) {
        result = [{}, {
          id: 'i',
          name: '筛选会员营销',
          createTime: '2020-02-02 10:00:00',
          excuteTime: '2020-02-02 10:00:00',
          sendCrowd: '促销人群',
          sendCrowdNum: 100,
          sendSuccessNum: 500,
          sendStatusOrder: 3,
          sendStatus: '未推送',
        }];
      }

      result.push({
        id: `${i }i`,
        name: `筛选会员营销${ i}`,
        createTime: `2020-02-02 10:00:00${ i}`,
        excuteTime: `2020-02-02 10:00:00${ i}`,
        sendCrowd: i % 2 ? '促销人群' : '/',
        sendCrowdNum: 100 + i,
        sendSuccessNum: 500,
        sendStatusOrder: i % 2,
        sendStatus: i % 2 ? '推送中' : '推送成功',
      });
    }
    result.shift();
    return result;
  };


  /** 取消营销活动推送 */
  const cancelDataSend = (id: string): void => {
    Message.loading('取消推送中，请稍等...');

    Servlets('deleteMarketingtaskOld', {Id: id }).then((res: { success: boolean; data: object }) => {
      if (!res.success || !res.data) return;

      getListData({pageNo: pageInfo.pageNo, pageSize: pageInfo.pageSize});
      setTimeout(() => {
        Message.success({ title: '已取消推送', duration: 1500 });
      }, 500);
    });
  };


  /** 搜索表单提交时触发 */
  const handleSubmit = (val: any): void => {
    console.log(val.createTime);

    // val.createTime = val.createTime ? [moment(val.createTime[0]).format('YYYY-MM-DD'), moment(val.createTime[1]).format('YYYY-MM-DD')] : "";
    // val.excuteTime = val.excuteTime ? [moment(val.excuteTime[0]).format('YYYY-MM-DD'), moment(val.excuteTime[1]).format('YYYY-MM-DD')] : "";
    const searchForm = {
      ...{
        name: val.name, // 营销主题
        status: val.sendStatus, // 活动状态
        type: 2, // 活动类型 1:人群营销 2：订单筛选营销
      },

      ...{ // 时间区间处理
        createStartTime: val.createTime?.length > 0 ? moment(val.createTime[0] * 1000).unix() : '', // 创建时间 开始
        createEndTime: val.createTime?.length > 0 ? moment(val.createTime[1]).format('x'): '', // 创建时间 结束

        pushStartTime: val.excuteTime?.length > 0 ? moment(val.excuteTime[0] * 1000).unix() : '', // 推送时间 起始
        pushEndTime: val.excuteTime?.length > 0 ? moment(val.excuteTime[1]).format('x'): '', // 推送时间 结束
      },
      ...{ // 分页
        pageNo: 1,
        pageSize: pageInfo.pageSize,
      },
    };
    getListData(searchForm);
    setSearchFormData(searchForm)
  };

  /** 搜索表单重置时触发 */
  const handleReset = (): void => {
    getListData();
    setSearchFormData({
      name: '', // 营销主题
      status: '', // 活动状态
      type: 2, // 活动类型 1:人群营销 2：订单筛选营销
      createStartTime:  '', // 创建时间 开始
      createEndTime:  '', // 创建时间 结束

      pushStartTime:  '', // 推送时间 起始
      pushEndTime:  '', // 推送时间 结束
    });
    setPageInfo({
      ...pageInfo,
      pageNo: 1,
      pageSize: 10,
    });
  };


  /** 列表数据格式配置项 */
  const getColumns = (): object[] => {
    const columns = [
      {
        title: '推送时间',
        dataIndex: 'excuteTime',
        width: 180,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return (<div>
            <span>{moment(record.excuteTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                  </div>);
        },
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        width: 180,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return (<div>
            <span>{moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                  </div>);
        },
      },
      {
        title: '营销主题',
        dataIndex: 'name',
        width: 180,
        alignHeader: 'left',
        align: 'left',
      },
      {
        title: '推送人群',
        dataIndex: 'packageName',
        width: 180,
        alignHeader: 'left',
        align: 'left',
      },
      {
        title: '推送人群数量',
        dataIndex: 'expectPeopleNum',
        width: 180,
        alignHeader: 'left',
        align: 'left',
      },
      {
        title:
        <div>
        <span>推送成功人数</span>
        <Balloon.Tooltip
          id="aria-tooltip"
          align="t"
          trigger={
            <span className={`${style['icon-style']} iconfont icon-icon4-33`}></span>
          }
        >
          发送成功后获取
        </Balloon.Tooltip>
        </div>,
        width: 180,
        dataIndex:"reachPeopleNum"
      },
      {
        title: '状态',
        width: 100,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          const arr = [LzTag.Disable, LzTag.Success, LzTag.Success, LzTag.Error, LzTag.Error];
          const wd = ['未执行', '执行中', '执行成功', '执行失败', '停止'];
          const Content = arr[record.status];
          return (<div style={{ userSelect: 'none' }}>
            <Content>{wd[record.status]}</Content>
                  </div>);
        },
      },
      {
        title: '操作',
        lock: 'right',
        width: 240,
        alignHeader: 'left',
        align: 'left',
        lock: 'right',
        cell: (value, index, record) => {
          return (<div>
            {/* 20241031 针对订单筛选功能提测，把做不到的营销效果页面下掉 */}
            {
              record.status === 2 && Number(moment().format('x')) > Number(moment(record.excuteTime).add(1,'days').startOf('days').add(10,'hours').format('x')) ? <Button
                type="primary"
                text
                onClick={() => openDialog_MarketingEffect(true, record)}
              >营销效果
                                    </Button> :
              <span style={{ color: '#C3CBD6', cursor: 'no-drop' }}>营销效果</span>
            }

            <Button
              type="primary"
              text
              onClick={() => showShorMessageDialog(record)}
              style={{ marginLeft: '10px' }}
            >短信内容
            </Button>

            {
              (record.excuteType === 1 && record.status === 0)
                ?
                  <Button
                    type="primary"
                    style={{ marginLeft: '10px' }}
                    text
                    onClick={() => cancelDataSend(record.id)}
                  >&nbsp;&nbsp;取消推送
                  </Button>
                :
                  <span style={{ color: '#C3CBD6', cursor: 'no-drop', marginLeft: '10px' }}>取消推送</span>
            }
                  </div>);
        },
      },

    ];

    return columns;
  };

  /** 展示短信内容 */
  const showShorMessageDialog = (record: { smsSign: string; smsContent: string; shortUrl: string } = {
    smsSign: '',
    smsContent: '',
    shortUrl: '',
  }): void => {
    const smsTotalNum = record.smsSign.length + record.smsContent.length + record.shortUrl.length+2
    const dialog = Dialog.show({
      title: '短信内容',
      className: 'quickDialog_hjy',
      content:
  <div className="container">
    <p className="title">短信内容：</p>
    <p className="content">【{record.smsSign}】{record.smsContent}{record.shortUrl}</p>
    {/* bug 77010 */}
    <p className="info">字数/计费（条）：<span>{smsTotalNum}/{smsTotalNum<=70 ? Math.ceil(smsTotalNum/70) :  Math.ceil(smsTotalNum/67)} </span></p>
  </div>,
      footer: (
        <Button className="close" warning type="secondary" onClick={() => dialog.hide()}>
          关闭
        </Button>
      ),
    });
  };

  /** 翻页方法 */
  const handlePageSizeChange = async (pages ={}): Promise<void> => {
    // setLoadingForList(true);
    // setTimeout(() => {
    //     setLoadingForList(false);
    // }, 500);
    getListData({
      ...searchFormData,
      pageNo: pages.pageNo,
      pageSize: pages.pageSize
    })
  };

  /** 打开营销效果弹窗 */
  const openDialog_MarketingEffect = (visible = true, record: object = {}): void => {
    /** 打开子页面 */
    // setOpenMarketingEffectDiglog(visible);
    /** 将用户点选的数据传入 子页面 */
    // setSelectedRowData(record);
    localStorage.setItem('tab', 'tabMarketing');
    // 路由跳转 -- 打开营销效果页面 ，
    appHistory.push(`./orderSelection/marketingEffect/${record.id}`);
  };



  return (
    <>
      <div style={{ minHeight: 700 }}>
        <div className={style.listSearch}>
          <Form
            inline
            className={`${style.listSearchForm} form-marketingActivity`}
            size="medium"
            value={searchFormData}
          >
            <FormItem label="营销主题:" className={style.formItem}>
              <Input
                name="name"
                className={style.formItem_width}
                placeholder="请输入..."
                maxLength={100}
                hasClear
              />
            </FormItem>
            <FormItem label="创建时间:" className={style.formItem}>
              <RangePicker
                name="createTime"
                placeholder="请点选..."
                popupAlign="tr tr"
                className={style.formItem_width}
                followTrigger
                disabledDate={(date, view) => utils.disabledDate(date, view, 'back', false)}
                showTime={{ defaultValue: defaultTimeValues,format: 'HH:mm:ss' }}
              />
            </FormItem>
            <FormItem label="推送时间:" className={style.formItem}>
              <RangePicker
                name="excuteTime"
                placeholder="请点选..."
                popupAlign="tr tr"
                className={style.formItem_width}
                followTrigger
                showTime={{defaultValue: defaultTimeValues, format: 'HH:mm:ss' }}
              />
            </FormItem>
            <FormItem label="状态类型:" className={style.formItem}>
              <Select
                placeholder="请点选..."
                name="sendStatus"
                className={style.formItem_width}
                hasClear
                dataSource={orderStatusDisc}
                followTrigger
              />
            </FormItem>
            <FormItem
              label=""
              className={`${style.formItem} form-marketingActivity-btn`}
              style={{ textAlign: 'right' }}
            >
              <Form.Submit
                type="primary"
                onClick={handleSubmit}
                className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}
              >查询
              </Form.Submit>
              <Form.Reset
                className={`${style.submitBtnStyle_width}`}
                onClick={handleReset}
              >重置
              </Form.Reset>
            </FormItem>
          </Form>

        </div>

        <div className={style.childBox}>

          <ParagraphTitle title="活动列表" subtitle="" />
          {/* 列表 */}
          <div className={style.listContent}>

            <div style={{ marginTop: 8 }}>
              <Table
                dataSource={dataSource}
                fixedHeader
                maxBodyHeight={460}
                loading={isLoadingForList}
                columns={columns}
              >
                {
                  columns.map((item: any, index: number) => {
                    return (
                      <Table.Column
                        title={item.title}
                        key={index}
                        dataIndex={item.dataIndex}
                        cell={item.cell}
                        align={item.align}
                        width={item.width}
                        alignHeader={item.alignHeader}
                        lock={item.lock}
                        htmlTitle={item.htmlTitle}
                      />
                    );
                  })
                }
              </Table>
            </div>

            {
              !!dataSource.length &&
              <div attr-intro="分页组件" className={[style.Pagination, 'Hjy-Pagination'].join(' ')}>
                <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
              </div>
            }
          </div>
        </div>

      </div>
    </>
  );
};


export default Tabs_marketingActivityList;
